module.exports = __webpack_public_path__ + "static/media/PaymentGiftCard.7771b17c.png";